import t from '../translate'
import Field from "../components/Field";
import { useFormikContext } from 'formik'
import React, { useState, useEffect } from 'react'
import config from "../../config/config.json";
import Modal from 'react-bootstrap/Modal';

function Attachment ({ number = 0, category, canRemoveAttachment = true, removeAttachment }) {
  const { values, touched, errors, setFieldValue } = useFormikContext()
  const noFileSelectedText = t('send.attachments.uploadButton.noFileSelected');
  const categoryName = t(`send.attachments.${category}.title`);
  const allowedFileTypes = (config?.allowed_tile_types ?? ["application/pdf"]).join(", ");
  let fileText = values?.send?.attachments?.[category]?.[number]?.fileName ?? noFileSelectedText;
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setFieldValue(`send.attachments.${category}.${number}.file`, file || null);
      setFieldValue(`send.attachments.${category}.${number}.fileSize`, file.size);
      setFieldValue(`send.attachments.${category}.${number}.fileType`, file.type);
      setFieldValue(`send.attachments.${category}.${number}.fileName`, file.name);
      setFieldValue(`send.attachments.${category}.${number}.description`, '');
      setFieldValue(`send.attachments.${category}.${number}.category`, categoryName);
    }
  };

  return <div>
    
    <div className="row align-items-center mb-4">
      <div className="col">
        <label
          htmlFor={`send.attachments.${category}.${number}.description`}>{t(
          `send.attachments.description`)}</label>
        <Field
          type="text"
          id={`send.attachments.${category}.${number}.description`}
          name={`send.attachments.${category}.${number}.description`}
          className={
            (touched?.send?.attachments?.[category]?.[number]?.description &&
              errors?.send?.attachments?.[category]?.[number]?.description)
              ? "touched error"
              : ""
          }
        />
      </div>
      <div className='col attachment-text-desktop text-end'>
        <br></br>
        <span style={{'color': '#003366'}}>
          {fileText}
        </span>
      </div>
      {canRemoveAttachment && <>
        <div className="col-auto justify-content-end">
          <br></br>
          <button type="button" className="button removeFile" onClick={removeAttachment}>
            <img src="/images/trash-icon-30x25.png"/>
          </button>
        </div>
        </>
      }
    </div>
    <div className="row align-items-center mb-4">
      <div className="col-auto">
        <button type="button" 
                className={((touched?.send?.attachments?.[category]?.[number] && errors?.send?.attachments?.[category]?.[number]) 
                ? "touched error" : "") + " upload"}>
          <i className="fa fa-upload"></i> {t('send.attachments.uploadButton.text')}
          <input type="file" 
                accept={allowedFileTypes}
                required={true}
                onChange={handleFileChange}/>
        </button>
      </div>

      <div className="col attachment-text-mobile" style={{'overflow': 'hidden'}}>
        <span style={{'color': '#003366'}}>
          {fileText}
        </span>
      </div>
    </div>
  </div>
}

function Attachments ({ min = 0, max = 10, category}) {
  let { values, setFieldValue } = useFormikContext()
  const labelNew = t('send.new')
  
  let attachments = []
  if (values?.send?.attachments && category) {
    attachments = values.send.attachments[category] || [];
  }

  let attachmentNumber = Math.max(attachments.length, min);
  let canRemoveAttachment = attachmentNumber > min;
  let canAddAttachment = attachmentNumber < max;

  function addAttachment () {
    attachments.push({})
    setFieldValue(`send.attachments.${category}`, attachments)
  }

  function removeAttachment(index) {
    if (canRemoveAttachment) {
      let newAttachments = attachments.filter((_, i) => i !== index); 
      setFieldValue(`send.attachments.${category}`, newAttachments);
    }
  }

  return <>
    <div className={'mt-4'} >
      {((attachmentNumber) => {
        let attachments = []
        for (let i = 0; i < attachmentNumber; i++) {
          attachments.push(<Attachment key={i} 
                                       number={i} 
                                       category={category} 
                                       canRemoveAttachment={canRemoveAttachment}
                                       removeAttachment={() => removeAttachment(i)}/>)
        }
        return attachments
      })(attachmentNumber)}
    </div>
    {canAddAttachment &&
      <button type={'button'} className={'button addFile mb-4'} 
              onClick={addAttachment}>{labelNew}</button>
    }
  </>
}

export default function SendStep ({program}) {
  const { touched, errors } = useFormikContext()
  const [showGeneral, setShowGeneral] = useState();
  const [showContract, setShowContract] = useState();
  const [showPrivacy, setShowPrivacy] = useState();

  let isBusinessCoach = program?.bezeichnung == "Senior Business Coach"
  let existsMainError = touched?.send?.attachments && errors?.send?.attachments && typeof errors?.send?.attachments === 'string'


  const getProgramTitle = () => {
    return program.bezeichnung;
  }

  const handleClose = () => {
    setShowGeneral(false);
    setShowContract(false);
    setShowPrivacy(false);
  };
  const handleShow = (target) => {
    switch (target) {
      case 'general':
        setShowGeneral(true);
        break;
      case 'contract':
        setShowContract(true);
        break;
      case 'privacy':
        setShowPrivacy(true);
        break;
      default:
        break;
    }
  };

  useEffect(() => {

    const generalSpan = document.querySelector('.general-modal-link');
    if (generalSpan) {
      generalSpan.addEventListener('click', function() {
        handleShow('general');
      });
    }

    const contractSpan = document.querySelector('.contract-modal-link');
    if (contractSpan) {
      contractSpan.addEventListener('click', function() {
        handleShow('contract');
      });
    }

    const privacySpan = document.querySelector('.privacy-modal-link');
    if (privacySpan) {
      privacySpan.addEventListener('click', function() {
        handleShow('privacy');
      });
    }

    // Cleanup function to remove the event listener
    return () => {
      if (generalSpan) {
        generalSpan.removeEventListener('click', handleShow);
      }
      if (contractSpan) {
        contractSpan.removeEventListener('click', handleShow);
      }
      if (privacySpan) {
        privacySpan.removeEventListener('click', handleShow);
      }
    };
  }, []);

  return <div className="send">
      <h3>{t('send.title')}</h3>
      <div className="send-section mt-4">
        { isBusinessCoach &&
          <p dangerouslySetInnerHTML={{ __html: t('send.universityDegree.text') }}></p>
        }

        <h5>{t('send.attachments.resume.title')}</h5>
        <Attachments category={'resume'} min={isBusinessCoach ? 1 : 0} max={1}/>

        <h5>{t('send.attachments.grades.title')}</h5>
        <Attachments category={'grades'}/>

        <h5>{t('send.attachments.miscellaneous.title')}</h5>
        <Attachments category={'miscellaneous'}/>
        
        {existsMainError && <div style={{ color: "red" }}>{errors.send.attachments}</div>}

        <div style={{marginBottom: '2em'}}></div>

        <div className={'form-row mt-2'}>
          <div className="form-checkbox">
            <Field
              id={'send.general.accepted'}
              name="send.general.accepted"
              type="checkbox"
              
            />
            <label
              htmlFor={'send.general.accepted'}
              className="form-radio-label general-label"
              dangerouslySetInnerHTML={{ __html: t('send.acknowledgement.general.checkboxLabel') }}>
            </label>
          </div>
        </div>
        <div className={'form-row mt-2'}>
          <div className="form-checkbox">
            <Field
              id={'send.contract.accepted'}
              name="send.contract.accepted"
              type="checkbox"
              
            />
            <label
              htmlFor={'send.contract.accepted'}
              className="form-radio-label contract-label"
              dangerouslySetInnerHTML={{ __html: program.link_vertrag ? 
                                          t('send.acknowledgement.contract.checkboxBlankLinkLabel', { link: program.link_vertrag }) : 
                                          t('send.acknowledgement.contract.checkboxLabel') }}>
            </label>
          </div>
        </div>
        <div className={'form-row mt-2'}>
          <div className="form-checkbox">
            <Field
              id={'send.privacyPolicy.accepted'}
              name="send.privacyPolicy.accepted"
              type="checkbox"
              
            />
            <label
              htmlFor={'send.privacyPolicy.accepted'}
              className="form-radio-label privacy-label"
              dangerouslySetInnerHTML={{ __html: t('send.acknowledgement.privacyPolicy.checkboxLabel') }}>
            </label>
          </div>
        </div>
    </div>

    <Modal className='general-modal' show={showGeneral} onHide={handleClose} backdrop={false}>
      <Modal.Header closeButton>
      </Modal.Header>
      <Modal.Body>
        <h2>{t('send.acknowledgement.general.titel')}</h2>
        <div className='smallText' dangerouslySetInnerHTML={{ __html: t('send.acknowledgement.general.text') }}></div>
      </Modal.Body>
    </Modal>

    <Modal className='contract-modal' show={showContract} onHide={handleClose} backdrop={false}>
      <Modal.Header closeButton>
      </Modal.Header>
      <Modal.Body>
        <h2>{t('send.acknowledgement.contract.titel')}</h2>
        <div className='smallText' dangerouslySetInnerHTML={{ __html: t('send.acknowledgement.contract.text', { program: getProgramTitle() }) }}></div>
      </Modal.Body>
    </Modal>

    <Modal className='privacy-modal' show={showPrivacy} onHide={handleClose} backdrop={false}>
      <Modal.Header closeButton>
      </Modal.Header>
      <Modal.Body>
        <h2>{t('send.acknowledgement.privacyPolicy.titel')}</h2>
        <div className='smallText' dangerouslySetInnerHTML={{ __html: t('send.acknowledgement.privacyPolicy.text') }}></div>
      </Modal.Body>
    </Modal>
  </div>
}
